import * as React from "react";
const DownloadIcon = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.99992 13.333L5.83325 9.16634L6.99992 7.95801L9.16658 10.1247V3.33301H10.8333V10.1247L12.9999 7.95801L14.1666 9.16634L9.99992 13.333ZM4.99992 16.6663C4.54159 16.6663 4.14936 16.5033 3.82325 16.1772C3.49714 15.8511 3.33381 15.4586 3.33325 14.9997V12.4997H4.99992V14.9997H14.9999V12.4997H16.6666V14.9997C16.6666 15.458 16.5035 15.8505 16.1774 16.1772C15.8513 16.5038 15.4588 16.6669 14.9999 16.6663H4.99992Z"
      fill="#949494"
    />
  </svg>
);
export default DownloadIcon;
